import { ExternalTransaction } from '@helios/common-api'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const externalTransactionFeatureKey = 'externalTransaction'

export interface ExternalTxGridContext {
  sortByAbsolute?: boolean
}

export interface ExternalTxGridQuickFilters {
  unmatched: boolean
  held: boolean
  ignored: boolean
  matched: boolean
}

export interface ExternalTxGridAdvancedOptions {
  resetFiltersOnNewAccountLoad?: boolean
}

export interface ExternalData {
  postDate?: string
  amount?: number
  entryDate?: string
  settleDate?: string
  units?: number
  price?: number
  commission?: number
  accrued?: number
  factor?: number
}

export interface ExternalTransactionRedux {
  externalTransactions: ExternalTransaction[]
}

export const externalTransactionInitialState: ExternalTransactionRedux = {
  externalTransactions: [],
}

export const externalTransactionSlice = createSlice({
  name: externalTransactionFeatureKey,
  initialState: externalTransactionInitialState,
  reducers: {
    setExternalTransactions: (
      oldState,
      action: PayloadAction<ExternalTransaction[]>,
    ) => ({
      ...oldState,
      externalTransactions: action.payload,
    }),
    clearExternalTransactions: oldState => ({
      ...oldState,
      externalTransactions: [],
    }),
  },
})

export const { setExternalTransactions, clearExternalTransactions } =
  externalTransactionSlice.actions

export default externalTransactionSlice.reducer
